import React from "react";
import RevealAnimation from "../RevealAnimation";

function MarktingHeroBanner({
  title = "",
  subTitle = "",
  ctaTitle1 = "Secure My Credits",
}) {
  return (
    <div className="body-container">
      <div className="promo-banner">
        <RevealAnimation animation="slide-left">
          <h4 className="amount">{title}</h4>
        </RevealAnimation>
        <RevealAnimation animation="slide-left">
          <div className="description text-gray-dark">{subTitle}</div>
        </RevealAnimation>
        <div className="cta-buttons">
          <a href="#contact-aws-saving" className="cta-button primary">
            {ctaTitle1}
          </a>
          <a
            href="https://calendly.com/harry-digiryte/discoverycall"
            target="_blank"
            className="cta-button secondary"
          >
            Book 15-min Call
          </a>
        </div>
      </div>
    </div>
  );
}

export default MarktingHeroBanner;
